import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../assets/images/theme/loading.gif'


const _hoisted_1 = { class: "account-wrapper text-left mt-3" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = {
  key: 0,
  class: "column is-4 friHubcol1 ms-3"
}
const _hoisted_4 = {
  class: "account-box is-navigation p-0 mt-0",
  style: {"border":"none !important"}
}
const _hoisted_5 = { class: "account-menu me-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-user-alt"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-qr-code fs-3 align-middle" }),
  /*#__PURE__*/_createTextVNode(" Dispositivo")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-quill"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-wifi fs-3 align-middle me-3" }),
  /*#__PURE__*/_createTextVNode("Sensores")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-quill"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell fs-3 align-middle me-3" }),
  /*#__PURE__*/_createTextVNode("Alarmas")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-quill"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear fs-3 align-middle me-3" }),
  /*#__PURE__*/_createTextVNode("Configuración")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-quill"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-compact-left fs-3 align-middle me-3" }),
  /*#__PURE__*/_createTextVNode("Volver")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "form-head-inner" }
const _hoisted_27 = {
  key: 0,
  class: "left"
}
const _hoisted_28 = {
  class: "inline-block align-top me-1 fs-6 mt-0",
  style: {"margin-top":"4px"}
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock pe-0 fs-6" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "pt-2 pb-2 fs-5 friBack1 mt-3 text-white text-left ps-3 br-5" }, "Dispositivo", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell fs-4 align-middle me-1" }, null, -1)
const _hoisted_32 = { class: "align-middle fw-bold fs-5" }
const _hoisted_33 = {
  key: 0,
  class: "fs-6"
}
const _hoisted_34 = {
  key: 1,
  class: "fs-6 p-3 font-bold text-center friBack4 m-2 br-5"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell fs-4 align-middle me-1" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "El dispositivo no dispone de alarmas activas.", -1)
const _hoisted_37 = {
  key: 1,
  class: "p-3 text-left text-xs2"
}
const _hoisted_38 = {
  key: 0,
  class: "align-middle fs-6 pb-1 text-left"
}
const _hoisted_39 = { class: "fw-normal" }
const _hoisted_40 = {
  key: 1,
  class: "align-middle pe-2"
}
const _hoisted_41 = { class: "fw-bold" }
const _hoisted_42 = {
  key: 2,
  class: "align-middle"
}
const _hoisted_43 = { class: "fw-bold" }
const _hoisted_44 = {
  key: 3,
  class: "align-middle"
}
const _hoisted_45 = { class: "fw-bold" }
const _hoisted_46 = {
  key: 4,
  class: "align-middle"
}
const _hoisted_47 = { class: "fw-bold" }
const _hoisted_48 = { class: "mx-3 mt-4" }
const _hoisted_49 = { class: "align-middle" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 0,
  style: {"padding-bottom":"20px"}
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "d-flex justify-content-center" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  key: 0,
  class: "bi bi-door-open-fill align-middle",
  style: {"font-size":"50px","color":"#ff0000"}
}
const _hoisted_56 = {
  key: 1,
  class: "bi bi-door-closed-fill align-middle",
  style: {"font-size":"50px","color":"#ddd"}
}
const _hoisted_57 = { class: "mt-0 text-xs" }
const _hoisted_58 = { class: "text-center" }
const _hoisted_59 = {
  class: "fw-normal mb-0 mt-3 ms-1",
  style: {"font-size":"35px","line-height":"20px"}
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs ps-1" }, "ºC", -1)
const _hoisted_61 = { class: "fs-4 fw-normal mt-0" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "%", -1)
const _hoisted_63 = {
  key: 0,
  class: "text-center"
}
const _hoisted_64 = ["src"]
const _hoisted_65 = {
  key: 1,
  class: "alarm-exclamation mt-2 me-1"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell-fill fs-5" }, null, -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = { class: "mt-3 fs-6" }
const _hoisted_69 = { class: "mt-0 text-xs" }
const _hoisted_70 = {
  key: 0,
  class: "text-center mt-2"
}
const _hoisted_71 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_72 = {
  key: 1,
  class: "text-center mb-5",
  style: {"margin-top":"40px"}
}
const _hoisted_73 = {
  key: 1,
  class: "mx-5"
}
const _hoisted_74 = { class: "pt-2 pb-2 fs-5 friBack1 mt-3 text-white text-left ps-3 br-5" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "Sensores ", -1)
const _hoisted_76 = {
  fill: "clear",
  class: "float-end me-3"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-wifi fs-3 align-middle" }, null, -1)
const _hoisted_78 = { class: "align-middle ps-2" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-center mb-5",
  style: {"margin-top":"40px"}
}, "No hay sensores registrados", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button button v-button py-05 mt-2",
    type: "button",
    "aria-hidden": "false"
  }, "Añadir sensor")
], -1)
const _hoisted_81 = {
  key: 2,
  class: "mx-5"
}
const _hoisted_82 = { class: "pt-2 pb-2 fs-5 friBack1 mt-3 text-white text-left ps-3 br-5" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "Alarmas ", -1)
const _hoisted_84 = {
  fill: "clear",
  class: "float-end me-3"
}
const _hoisted_85 = { class: "mt-3 p-3 fs-5 fw-bold" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell-fill fs-4 align-middle text-danger" }, null, -1)
const _hoisted_87 = { class: "align-middle ps-1 text-danger" }
const _hoisted_88 = {
  key: 0,
  class: "ps-1 text-xs"
}
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 p-3 fs-5 fw-bold" }, "Silenciadas", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "text-center my-3" }, "No hay alarmas silenciadas", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "Alarma", -1)
const _hoisted_92 = { class: "align-middle text-xs2 pt-2 ps-1" }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-bell align-middle mt-5",
    style: {"font-size":"50px"}
  })
], -1)
const _hoisted_95 = {
  class: "fs-3 fw-bold",
  style: {"text-align":"center"}
}
const _hoisted_96 = {
  key: 0,
  class: "fs-6 text-center"
}
const _hoisted_97 = {
  class: "fs-1 text-danger fw-bold",
  style: {"text-align":"center"}
}
const _hoisted_98 = { class: "text-center my-3" }
const _hoisted_99 = {
  key: 0,
  class: "badge bg-danger fs-2"
}
const _hoisted_100 = { class: "text-center my-3" }
const _hoisted_101 = {
  key: 0,
  class: "badge bg-light text-danger fs-6 fw-normal px-5"
}
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { class: "pb-2" }
const _hoisted_105 = { class: "text-center mt-5" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "pe-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-down-arrow" }),
  /*#__PURE__*/_createTextVNode(" Mínima:")
], -1)
const _hoisted_107 = {
  key: 0,
  class: "badge bg-secondary fs-6"
}
const _hoisted_108 = /*#__PURE__*/_createElementVNode("span", { class: "pe-2 ps-5" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-graph-up-arrow" }),
  /*#__PURE__*/_createTextVNode(" Máxima:")
], -1)
const _hoisted_109 = {
  key: 1,
  class: "badge bg-secondary fs-6"
}
const _hoisted_110 = {
  key: 1,
  class: "mx-5 text-center mt-3 pb-2"
}
const _hoisted_111 = { class: "mx-5" }
const _hoisted_112 = { class: "text-center mt-2" }
const _hoisted_113 = {
  key: 0,
  class: "badge bg-secondary fs-6 px-5 fw-normal pb-2"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-whatsapp pe-2" }, null, -1)
const _hoisted_115 = {
  class: "mt-2 text-center mb-5",
  style: {"padding":"10px 0"}
}
const _hoisted_116 = {
  key: 3,
  class: "mx-5"
}
const _hoisted_117 = { class: "pt-2 pb-2 fs-5 friBack1 mt-3 text-white text-left ps-3 br-5" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "Configuración ", -1)
const _hoisted_119 = {
  fill: "clear",
  class: "float-end me-3"
}
const _hoisted_120 = {
  key: 0,
  class: "text-center p-5 mx-5 friBack1 mt-5 text-white"
}
const _hoisted_121 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"150px"}
}, null, -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Adquiriendo información"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Espere por favor ...")
], -1)
const _hoisted_123 = [
  _hoisted_121,
  _hoisted_122
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_input = _resolveComponent("ion-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isMobile && _ctx.layout.gatewayId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["account-menu-item cursor-pointer", _ctx.layout.section == 'dashboard' ? 'router-link-active router-link-exact-active' : '']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.layout.section = 'dashboard'))
                }, _hoisted_9, 2),
                (_ctx.layout.gateway && _ctx.layout.gateway.active)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["account-menu-item mt-2 cursor-pointer", _ctx.layout.section == 'sensors' ? 'router-link-active router-link-exact-active' : '']),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.layout.section = 'sensors'))
                      }, _hoisted_13, 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["account-menu-item mt-2 cursor-pointer", _ctx.layout.section == 'alarms' ? 'router-link-active router-link-exact-active' : '']),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.layout.section = 'alarms'))
                      }, _hoisted_17, 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["account-menu-item mt-2 cursor-pointer", _ctx.layout.section == 'settings' ? 'router-link-active router-link-exact-active' : '']),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.layout.section = 'settings'))
                      }, _hoisted_21, 2),
                      _createElementVNode("div", {
                        class: "account-menu-item mt-2 cursor-pointer",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/devices/')))
                      }, _hoisted_25)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.layout.gatewayId)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["column ps-0", _ctx.isMobile ? 'is-12' : 'is-8']),
            id: "friHubcol2"
          }, [
            _createElementVNode("div", {
              class: "account-box is-form is-footerless",
              style: _normalizeStyle(_ctx.isMobile ? 'border-bottom: none !important;' : '')
            }, [
              (_ctx.layout.gateway)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["form-head stuck-header", _ctx.isMobile ? 'py-0' : 'py-3'])
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      (_ctx.layout?.gateway?.name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("h4", {
                              class: _normalizeClass(["fw-bold", _ctx.isMobile ? 'fs-3 my-3 ms-2' : 'fs-4'])
                            }, _toDisplayString(_ctx.layout?.gateway?.name), 3)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createTextVNode(" " + _toDisplayString(_ctx.layout.currentTime), 1)
                      ])
                    ])
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["form-body p-0 m-0", _ctx.isMobile ? 'pt-0' : 'p-2'])
              }, [
                (_ctx.layout.gateway && _ctx.layout.gateway.active)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.layout.section == 'dashboard')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(_ctx.isMobile ? 'mx-5' : 'mx-3')
                          }, [
                            _hoisted_30,
                            (_ctx.layout.gateway?.status)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.layout.gateway?.status?.alarms)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "p-2 font-bold text-center friBorder3 friColor3 my-2 br-5 cursor-pointer",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.layout.section = 'alarms'))
                                      }, [
                                        _hoisted_31,
                                        _createTextVNode(),
                                        _createElementVNode("span", _hoisted_32, [
                                          _createTextVNode("Alarmas activas "),
                                          (_ctx.layout.gateway?.status?.alarmsCount)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_33, "(" + _toDisplayString(_ctx.layout.gateway?.status?.alarmsCount) + ")", 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                        _hoisted_35,
                                        _createTextVNode(),
                                        _hoisted_36
                                      ]))
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.profile?.isRoot)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  (_ctx.layout?.gateway?.id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        _createElementVNode("span", _hoisted_39, "ID: " + _toDisplayString(_ctx.layout.gateway.id), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.layout?.gateway?.ttn?.appId)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                        _createTextVNode("ttnID: "),
                                        _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.layout.gateway.ttn.gateway_id), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.layout?.gateway?.zerotier)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                        _createTextVNode("/ ttnAppId: "),
                                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.layout.gateway.ttn.appId), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.layout?.gateway?.notify)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                        _createTextVNode("IP: "),
                                        _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.layout.gateway.zerotier), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.layout?.gateway?.notify)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                        _createTextVNode("Notificaciones: "),
                                        _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.layout.gateway.notify.alarms ? 'Activas' : 'Inativas'), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["fs-5 font-bold", _ctx.isMobile ? 'text-center' : 'text-left'])
                              }, [
                                _createElementVNode("span", _hoisted_49, [
                                  _createTextVNode("Sensores "),
                                  (_ctx.layout?.gateway?.devices)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, "(" + _toDisplayString(Object.keys(_ctx.layout.gateway.devices).length) + ")", 1))
                                    : _createCommentVNode("", true)
                                ])
                              ], 2),
                              (Object.keys(_ctx.layout.gateway.devices).length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                    _createVNode(_component_ion_grid, { class: "mt-3" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_row, null, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.gateway.devices, (deviceData, deviceId) => {
                                              return (_openBlock(), _createBlock(_component_ion_col, {
                                                key: deviceId,
                                                class: "mb-5"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", {
                                                    class: "align-middle mt-2 cursor-pointer text-center",
                                                    onClick: ($event: any) => (_ctx.$router.push({ path: '/sensor/'+_ctx.layout.gatewayId + '/' + deviceId, query: { section: 'dashboard' } }))
                                                  }, [
                                                    _createElementVNode("div", _hoisted_53, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["circle-icon-wrapper text-center", deviceData.status.alarm.status ? 'circle-alarm' : '']),
                                                        style: {"position":"relative"}
                                                      }, [
                                                        (deviceData.type == 'door')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                              (deviceData.status?.msg?.DOOR_OPEN_STATUS)
                                                                ? (_openBlock(), _createElementBlock("i", _hoisted_55))
                                                                : (_openBlock(), _createElementBlock("i", _hoisted_56)),
                                                              _createElementVNode("div", _hoisted_57, [
                                                                (deviceData.status?.msg?.DOOR_OPEN_STATUS)
                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                      _createTextVNode("Abierta")
                                                                    ], 64))
                                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                      _createTextVNode("Cerrada")
                                                                    ], 64))
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        _createElementVNode("div", _hoisted_58, [
                                                          (deviceData.type == 'dht')
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createElementVNode("div", _hoisted_59, [
                                                                  _createTextVNode(_toDisplayString(parseFloat(deviceData.status?.msg?.TempC_SHT).toFixed(0)), 1),
                                                                  _hoisted_60
                                                                ]),
                                                                _createElementVNode("div", _hoisted_61, [
                                                                  _createTextVNode(_toDisplayString(deviceData.status?.msg?.Hum_SHT), 1),
                                                                  _hoisted_62
                                                                ])
                                                              ], 64))
                                                            : _createCommentVNode("", true),
                                                          (deviceData.type == 'modbus')
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                (deviceData.image)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                                                      _createElementVNode("img", {
                                                                        src: 'data:image/jpeg;base64,' + deviceData.image,
                                                                        width: "95"
                                                                      }, null, 8, _hoisted_64)
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                              ], 64))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        (deviceData.status.alarm.status)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, _hoisted_67))
                                                          : _createCommentVNode("", true)
                                                      ], 2)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_68, _toDisplayString(deviceData.name), 1),
                                                    _createElementVNode("div", _hoisted_69, [
                                                      (deviceData.status?.date?.toDate().toLocaleDateString() == new Date().toLocaleDateString())
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createTextVNode("Hoy a las " + _toDisplayString(deviceData.status?.date?.toDate().toLocaleTimeString()), 1)
                                                          ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createTextVNode(_toDisplayString(deviceData.status?.date?.toDate().toLocaleString()), 1)
                                                          ], 64))
                                                    ]),
                                                    (deviceData.type == 'modbus')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                                          (deviceData.status?.date?.toDate().getTime() > (new Date().getTime() - 1800000))
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_71, "En línea"))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ], 8, _hoisted_52)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_72, "No hay sensores registrados"))
                            ])
                          ], 2))
                        : _createCommentVNode("", true),
                      (_ctx.layout.section == 'sensors')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _hoisted_75,
                              _createElementVNode("div", _hoisted_76, [
                                _createVNode(_component_ion_icon, {
                                  icon: _ctx.add,
                                  class: _normalizeClass(["p-0 m-0 text-white font-bold align-top p-0 m-0", _ctx.isMobile ? 'fs-1' : 'fs-2'])
                                }, null, 8, ["icon", "class"])
                              ])
                            ]),
                            (Object.keys(_ctx.layout.gateway.devices).length)
                              ? (_openBlock(), _createBlock(_component_ion_list, {
                                  key: 0,
                                  lines: "full"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.gateway.devices, (deviceData, deviceId) => {
                                      return (_openBlock(), _createBlock(_component_ion_item, {
                                        key: deviceId,
                                        onClick: ($event: any) => (_ctx.$router.push({ path: '/sensor/'+_ctx.layout.gatewayId + '/' + deviceId, query: { section: 'dashboard' } })),
                                        class: "cursor-pointer",
                                        style: {"--ion-item-border-color":"#ccc"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _hoisted_77,
                                              _createTextVNode(),
                                              _createElementVNode("span", _hoisted_78, _toDisplayString(deviceData.name), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (deviceData.type == 'dht')
                                            ? (_openBlock(), _createBlock(_component_ion_label, {
                                                key: 0,
                                                class: "fs-6"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Temperatura/Humedad")
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_79,
                                  _hoisted_80
                                ], 64))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.layout.section == 'alarms')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                            _createElementVNode("div", _hoisted_82, [
                              _hoisted_83,
                              _createElementVNode("div", _hoisted_84, [
                                _createVNode(_component_ion_icon, {
                                  icon: _ctx.add,
                                  class: _normalizeClass(["p-0 m-0 text-white font-bold align-top p-0 m-0", _ctx.isMobile ? 'fs-1' : 'fs-2'])
                                }, null, 8, ["icon", "class"])
                              ])
                            ]),
                            (_ctx.layout.gateway.status.alarms)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_85, "Activas (" + _toDisplayString(_ctx.layout.gateway.status.alarmsCount) + ")", 1),
                                  _createVNode(_component_ion_list, {
                                    lines: "full",
                                    class: "p-0"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.gateway.status.alarmsActive, (alarm, alarmId) => {
                                        return (_openBlock(), _createBlock(_component_ion_item, {
                                          key: alarmId,
                                          class: "cursor-pointer",
                                          style: {"--ion-item-border-color":"#ccc"},
                                          onClick: ($event: any) => (_ctx.layout.alarm=alarm)
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => [
                                                _hoisted_86,
                                                _createTextVNode(),
                                                _createElementVNode("span", _hoisted_87, [
                                                  _createTextVNode(_toDisplayString(alarm?.title) + " ", 1),
                                                  (alarm?.code)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_88, "(" + _toDisplayString(alarm.code) + ")", 1))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _: 2
                                            }, 1024),
                                            (alarm?.device?.name)
                                              ? (_openBlock(), _createBlock(_component_ion_label, {
                                                  key: 0,
                                                  class: "fs-6 text-end"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(alarm?.device?.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }),
                                  _hoisted_89,
                                  _hoisted_90
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.layout.alarm)
                              ? (_openBlock(), _createBlock(_component_ion_modal, {
                                  key: 1,
                                  "is-open": true
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_header, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_toolbar, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_title, null, {
                                              default: _withCtx(() => [
                                                _hoisted_91,
                                                _createTextVNode(),
                                                _createElementVNode("span", _hoisted_92, [
                                                  _createTextVNode(_toDisplayString(_ctx.layout?.alarm?.code) + " ", 1),
                                                  (_ctx.layout.alarm?.param && _ctx.profile.isRoot)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_93, "/ " + _toDisplayString(_ctx.layout.alarm.param), 1))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_ion_buttons, { slot: "end" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_button, {
                                                  class: "border-none",
                                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.layout.alarm=false))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Cerrar")
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_content, { class: "pb-5" }, {
                                      default: _withCtx(() => [
                                        _hoisted_94,
                                        _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.layout?.alarm?.device?.name), 1),
                                        (_ctx.layout?.alarm?.date)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(_ctx.layout?.alarm?.date), 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.layout?.alarm?.title), 1),
                                        _createElementVNode("div", _hoisted_98, [
                                          (_ctx.layout?.alarm?.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(_ctx.layout?.alarm?.value) + " ºc", 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_100, [
                                          (_ctx.layout?.alarm?.diff)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_101, [
                                                (_ctx.layout?.alarm?.diff)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_102, "+"))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_103, "-")),
                                                _createTextVNode(" " + _toDisplayString(parseFloat(_ctx.layout?.alarm?.diff).toFixed(2)) + " ºc", 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_104, [
                                          _createElementVNode("div", _hoisted_105, [
                                            _hoisted_106,
                                            (_ctx.layout?.alarm?.device?.config?.min)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_107, _toDisplayString(_ctx.layout?.alarm?.device?.config?.min) + " ºc", 1))
                                              : _createCommentVNode("", true),
                                            _hoisted_108,
                                            (_ctx.layout?.alarm?.device?.config?.max)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_109, _toDisplayString(_ctx.layout?.alarm?.device?.config?.max) + " ºc", 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        (_ctx.layout?.alarm?.description)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                              _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.layout.alarm.description), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_112, [
                                          (_ctx.layout?.alarm?.device?.config?.min)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_113, [
                                                _hoisted_114,
                                                _createTextVNode(" Notificada")
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_115, [
                                          _createElementVNode("button", {
                                            class: "button button v-button py-05 me-3 mt-5 friBack4",
                                            type: "button",
                                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.layout.alarm=false))
                                          }, "Silenciar"),
                                          _createElementVNode("button", {
                                            class: "button button v-button py-05 mt-5 friBack7 text-white",
                                            type: "button",
                                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.layout.alarm=false))
                                          }, "Descartar")
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.layout.section == 'settings')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                            _createElementVNode("div", _hoisted_117, [
                              _hoisted_118,
                              _createElementVNode("div", _hoisted_119, [
                                _createVNode(_component_ion_icon, {
                                  icon: _ctx.saveOutline,
                                  class: _normalizeClass(["p-0 m-0 text-white font-bold align-top p-0 m-0 cursor-pointer", _ctx.isMobile ? 'fs-1' : 'fs-2']),
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveDevice()))
                                }, null, 8, ["icon", "class"])
                              ])
                            ]),
                            (_ctx.layout.gateway.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_120, _toDisplayString(_ctx.layout.gateway.description), 1))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ion_list, {
                              class: _normalizeClass(_ctx.isMobile ? '' : 'mx-5')
                            }, {
                              default: _withCtx(() => [
                                (_ctx.profile.isRoot)
                                  ? (_openBlock(), _createBlock(_component_ion_item, {
                                      key: 0,
                                      lines: "full",
                                      style: {"--ion-item-border-color":"#ccc"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, {
                                          position: "floating",
                                          class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Id")
                                          ]),
                                          _: 1
                                        }, 8, ["class"]),
                                        _createVNode(_component_ion_input, {
                                          modelValue: _ctx.layout.gateway.id,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.layout.gateway.id) = $event)),
                                          type: "text",
                                          disabled: true,
                                          class: "fs-6"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_ion_item, {
                                  lines: "full",
                                  class: "border-none",
                                  style: {"--ion-item-border-color":"#ccc"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      position: "floating",
                                      class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Nombre")
                                      ]),
                                      _: 1
                                    }, 8, ["class"]),
                                    _createVNode(_component_ion_input, {
                                      modelValue: _ctx.layout.gateway.name,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.layout.gateway.name) = $event)),
                                      type: "text",
                                      autocomplete: "off"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"]),
                            _createVNode(_component_ion_list, {
                              class: _normalizeClass(_ctx.isMobile ? '' : 'mx-5')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  lines: "full",
                                  class: "border-none",
                                  style: {"--ion-item-border-color":"#ccc"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      position: "floating",
                                      class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Gateway Id")
                                      ]),
                                      _: 1
                                    }, 8, ["class"]),
                                    _createVNode(_component_ion_input, {
                                      modelValue: _ctx.layout.gateway.ttn.gateway_id,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.layout.gateway.ttn.gateway_id) = $event)),
                                      type: "text",
                                      disabled: true,
                                      autocomplete: "off"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_item, {
                                  lines: "full",
                                  class: "border-none",
                                  style: {"--ion-item-border-color":"#ccc"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      position: "floating",
                                      class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("AppId")
                                      ]),
                                      _: 1
                                    }, 8, ["class"]),
                                    _createVNode(_component_ion_input, {
                                      modelValue: _ctx.layout.gateway.ttn.appId,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.layout.gateway.ttn.appId) = $event)),
                                      type: "text",
                                      disabled: true,
                                      autocomplete: "off"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_item, {
                                  lines: "full",
                                  class: "border-none",
                                  style: {"--ion-item-border-color":"#ccc"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, {
                                      position: "floating",
                                      class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("EUI")
                                      ]),
                                      _: 1
                                    }, 8, ["class"]),
                                    _createVNode(_component_ion_input, {
                                      modelValue: _ctx.layout.gateway.ttn.eui,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.layout.gateway.ttn.eui) = $event)),
                                      type: "text",
                                      disabled: true,
                                      autocomplete: "off"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "text-center",
                      style: _normalizeStyle(_ctx.isMobile ? 'padding-bottom: 50%' : 'padding-bottom: 30px')
                    }, _hoisted_123, 4))
              ], 2)
            ], 4)
          ], 2))
        : _createCommentVNode("", true)
    ])
  ]))
}